<script>
import Photo from "./Photo";
import Tabs from "./Tabs/Index";
import FormData from "./FormData/Index";
import Description from "@/components/_Shared/Forms/Description";

import { mapActions } from "vuex";

export default {
  data() {
    return {
      preloader: false,
      professional: null
    };
  },

  components: {
    Photo,
    FormData,
    Tabs,
    Description
  },

  async mounted() {
    this.getProfessional();
  },

  methods: {
    ...mapActions("professionals", ["updateProfilePicture", "getById"]),
    async getProfessional() {
      this.preloader = true;

      try {
        this.professional = await this.getById(this.$route.params.id);
      } catch (e) {
        throw e;
      }

      this.preloader = false;
    },

    async submitUploadProfilePicture(payload) {
      this.preloader = true;

      try {
        let profile_picture = await this.updateProfilePicture(payload);
        this.professional.account.profile.profile_picture = profile_picture;
      } catch (e) {
        this.$toast.error(e);
      }

      this.preloader = false;
    }
  }
};
</script>

<template>
  <div>
    <div class="box">
      <div class="content-edit">
        <div class="mr-30">
          <Photo
            v-if="professional"
            :professional="professional"
            :outsidePreloader="preloader"
            @update="submitUploadProfilePicture"
          />
        </div>

        <div v-if="professional" class="flex-1">
          <FormData :professional="professional" @refresh="getProfessional" />
        </div>
      </div>
    </div>

    <div class="box">
      <Tabs
        v-if="professional"
        :professional="professional"
        @refresh="getProfessional"
      />
    </div>
  </div>
</template>

<style scoped>
.content-edit {
  display: flex;
  flex-direction: row;
}

.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.flex-1 {
  flex: 1;
}

.flex-half {
  flex: 0.5;
}

@media (max-width: 768px) {
  .content-edit {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .btn-group {
    flex-direction: column;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Index.vue